import { SVGProps, Ref, forwardRef } from 'react';

export const PhoneArrowOutFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m5.67 0 3.91 5.62-1.3 3.045c-.217.506-.221 1.078.063 1.55.404.673 1.157 1.747 2.438 3.028 1.275 1.275 2.346 2.026 3.02 2.432.477.287 1.056.28 1.567.057l3.01-1.318L24 18.324c-2.605 9.193-11.002 5.93-17.618-.684C-.235 11.027-3.534 2.598 5.67 0m10.966 8.636L21.2 4.073V8H23V1h-7v1.8h3.927l-4.563 4.564z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
PhoneArrowOutFilledSize24Glyph.displayName = 'PhoneArrowOutFilledSize24Glyph';
